export enum StandardDonationAasmState {
  ACCEPTED = 'accepted',
  ARRIVED = 'arrived',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  DECLINED = 'declined',
  EN_ROUTED = 'en_routed',
  ENQUEUED = 'enqueued',
}
